import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronDown, FaSignOutAlt, FaUser } from "react-icons/fa";
import { HiMiniBars3CenterLeft } from "react-icons/hi2";
import imgIcon from "../assets/images/userIcon.png";
import { useAuth } from "../Context/AuthContext";
import logo from "../assets/images/logo.png";


const Topbar = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth(); // ✅ single source of truth

  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const userDropdownRef = useRef(null);
  const isMavroDomain = window.location.hostname === "mavro.app";

  const toggleUserDropdown = () => {
    setShowUserDropdown((prev) => !prev);
  };

  const handleLogout = () => {
    setShowUserDropdown(false);
    logout(); // clears state + storage + redirect
  };

  const handleProfileButton = () => {
    setShowUserDropdown(false);
    navigate("/profile-page");
  };

  const handleToggleSideBar = () => {
    console.log("clicked");
    document.body.classList.toggle("toggle-sidebar");
  };

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      userDropdownRef.current &&
      !userDropdownRef.current.contains(event.target)
    ) {
      setShowUserDropdown(false);
    }
  };

  const handleEsc = (event) => {
    if (event.key === "Escape") setShowUserDropdown(false);
  };

  document.addEventListener("mousedown", handleClickOutside);
  document.addEventListener("keydown", handleEsc);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    document.removeEventListener("keydown", handleEsc);
  };
}, []);


  // ⛔ Do not render Topbar user menu until user is ready
  if (!user) return null;

  return (
    <div className="dashboard-header">
      {/* LEFT */}
      <div className="header-left">
        <button className="menu-button" onClick={handleToggleSideBar}>
          <HiMiniBars3CenterLeft className="bar-icon" />
        </button>
      </div>

      {/* CENTER */}
<div className="header-center">
  {isMavroDomain ? (
    <div
  onClick={() => navigate("/home")}
  style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer"
  }}
>
  <img
    src="https://userrdocument.blob.core.windows.net/userdocument/companylogos/9001/3000/fe7c8f45-0332-44f9-aafa-317d66b3a66a_MAVR logo with pie chart symbol.png"
    alt="Company Logo"
    style={{
      marginTop: "10px",
      height: "140px",
      width: "auto",
      objectFit: "contain"
    }}
  />
  </div>
  ) : (
  <div
  onClick={() => navigate("/home")}
  style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer"
  }}
>
  <img
    src="https://userrdocument.blob.core.windows.net/userdocument/companylogos/9001/2000/bf8de4a5-c86e-4ec4-b488-f90041991c9c_Stylized%203D%20gradient%20sphere%20logo.png"
    alt="Company Logo"
    style={{
      height: "100px",
      width: "auto",
      objectFit: "contain"
    }}
  />
  <span
    style={{
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "1",
      whiteSpace: "nowrap",
      color: "#4DA3FF"
    }}
  >
    Navi1
  </span>
</div>
  )}
</div>
 
 


      {/* RIGHT */}
      <div className="header-right">
        <div className="user-dropdown-container" ref={userDropdownRef}>
          <button className="user-button" onClick={toggleUserDropdown}>
            <img src={imgIcon} alt="user" className="img-fluid user-icon" />
            <span className="username">{user.username || user.email}</span>
            <FaChevronDown className="down-icon" />
          </button>

          {showUserDropdown && (
            <div className="user-dropdown">
              <div className="user-role">
                <p>
                  <strong>Name:</strong> {user.username || "-"}
                </p>
                <p>
                  <strong>Email:</strong> {user.email}
                </p>

                {/* ✅ SAFE roles rendering */}
                {Array.isArray(user.roles) && user.roles.length > 0 && (
                  <p>
                    <strong>Roles:</strong> {user.roles.join(", ")}
                  </p>
                )}            
              </div>

              <button
                className="profile-dropdown-button"
                onClick={handleProfileButton}
              >
                <FaUser /> View Profile
              </button>

              <button className="logout-dropdown-button" onClick={handleLogout}>
                <FaSignOutAlt /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;






// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaChevronDown, FaSignOutAlt, FaUser } from "react-icons/fa";
// import { HiMiniBars3CenterLeft } from "react-icons/hi2";
// import imgIcon from "../assets/images/userIcon.png";
// import { useAuth } from "../Context/AuthContext";

// const Topbar = () => {
//   const navigate = useNavigate();
//   const { logout,user } = useAuth(); // ✅ Using AuthContext logout

//   const [userRole, setUserRole] = useState(null);
//   const [showUserDropdown, setShowUserDropdown] = useState(false);
//   const [dailyTimecard, setDailyTimecard] = useState("N");
//   const [ticketTimecard, setTicketTimecard] = useState("N");
//   const [showProfileModal, setShowProfileModal] = useState(false);
//   const [userDetails, setUserDetails] = useState(null);

//   const username = localStorage.getItem("username");

//   const toggleUserDropdown = () => {
//     setShowUserDropdown((prev) => !prev);
//   };

//   // Load user details once from localStorage
//   useEffect(() => {
//     try {
//       const storedUser = JSON.parse(localStorage.getItem("userDetails"));
//       if (storedUser) {
//         setUserDetails(storedUser);
//         setUserRole(storedUser?.role || "N/A");
//         setDailyTimecard(storedUser?.dailyTimecard || "N");
//         setTicketTimecard(storedUser?.ticketTimecard || "N");
//       }
//     } catch (error) {
//       console.error("Failed to parse user data from localStorage", error);
//     }
//   }, []);

//   // ✅ Use logout from AuthContext instead of re-implementing it
//   const handleLogout = () => {
//     setShowUserDropdown(false);
//     logout(); // This will clear localStorage, setUser(null), and navigate to /login
//   };

//   const handleProfileButton = () => {
//     setShowUserDropdown(false);
//     navigate("/profile-page");
//   };

//   const handleToggleSideBar = () => {
//     document.body.classList.toggle("toggle-sidebar");
//   };

//   return (
//     <>
//       <div className="dashboard-header">
//         <div className="header-left">
//           <button className="menu-button" onClick={handleToggleSideBar} >
//             <HiMiniBars3CenterLeft className="bar-icon" />
//           </button>
//         </div>

//         <div className="header-center">
//           <h2 className="dashboard-title" onClick={()=>navigate('/home')} style={{cursor:"pointer"}}>MAVRO</h2>
//         </div>

//         <div className="header-right">
//           {username && (
//             <div className="user-dropdown-container">
//               <button className="user-button" onClick={toggleUserDropdown}>
//                 <img src={imgIcon} alt="user" className="img-fluid user-icon" />
//                 <span className="username">{username}</span>
//                 <FaChevronDown className="down-icon" />
//               </button>

//               {showUserDropdown && (
//                 <div className="user-dropdown">
//                   <div className="user-role">
//                     <p>Name:&nbsp;{username}</p>
//                     <p>Role:&nbsp;{user.roles.join(", ")}</p>
//                   </div>
//                   <button
//                     className="profile-dropdown-button"
//                     onClick={handleProfileButton}
//                   >
//                     <FaUser /> View Profile
//                   </button>

//                   <button
//                     className="logout-dropdown-button"
//                     onClick={handleLogout}
//                   >
//                     <FaSignOutAlt /> Logout
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Profile Modal */}
//       {showProfileModal && userDetails && (
//         <div
//           className="modal-overlay"
//           onClick={() => setShowProfileModal(false)}
//         >
//           <div
//             className="profile-modal"
//             onClick={(e) => e.stopPropagation()} // prevent closing on modal click
//           >
//             <button
//               className="modal-close-icon"
//               onClick={() => setShowProfileModal(false)}
//             >
//               &times;
//             </button>
//             <h2>User Profile</h2>
//             <div className="profile-details">
//               <p><strong>User ID:</strong> {userDetails.userId}</p>
//               <p><strong>Organisation ID:</strong> {userDetails.organisationId}</p>
//               <p>
//                 <strong>Username:</strong>{" "}
//                 {userDetails.username
//                   ? userDetails.username.charAt(0).toUpperCase() +
//                     userDetails.username.slice(1)
//                   : ""}
//               </p>
//               <p><strong>Email:</strong> {userDetails.email}</p>
//               <p><strong>Role:</strong> {userDetails.role}</p>
//               <p>
//                 <strong>Daily Timecard:</strong>{" "}
//                 {userDetails.dailyTimecard === "Y" ? "Yes" : "No"}
//               </p>
//               <p>
//                 <strong>Ticket Timecard:</strong>{" "}
//                 {userDetails.ticketTimecard === "Y" ? "Yes" : "No"}
//               </p>
//               {userDetails.roles && (
//                 <p>
//                   <strong>All Roles:</strong> {userDetails.roles.join(", ")}
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Topbar;
